export default __webpack_public_path__ + "static/brush-stroke-dc82946f5a17833dca32bf8f5ce68a42.svg";